const initialState = {
  list: [],
  fetching: false,
  fetched: false,
  errors: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "METRIC_DISPLAY_STATUSES_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: null,
      }
    case "METRIC_DISPLAY_STATUSES_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "METRIC_DISPLAY_STATUSES_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        list: action.payload.data,
        errors: null,
      }
    default:
      return state
  }
}
